import { useCallback, useMemo, useState } from "react";

const BASE_CRUMB = { label: "Knowledge Hub" };

const buildItems = ({ pageLabel, pageHref, subLabel, subHref, tabLabel, tabHref }) => {
  // Si pageLabel es null pero hay pageHref, agregar href al BASE_CRUMB
  const baseCrumb = pageLabel === null && pageHref
    ? { ...BASE_CRUMB, href: pageHref }
    : BASE_CRUMB;
  
  const items = [baseCrumb];

  if (pageLabel) {
    items.push({
      label: pageLabel,
      ...(pageHref ? { href: pageHref } : {}),
    });
  }

  if (subLabel) {
    items.push({
      label: subLabel,
      ...(subHref ? { href: subHref } : {}),
    });
  }

  if (tabLabel) {
    items.push({
      label: tabLabel,
      ...(tabHref ? { href: tabHref } : {}),
    });
  }

  return items;
};

export const useKnowledgeBreadcrumbs = () => {
  const [items, setItems] = useState([BASE_CRUMB]);

  const addItem = useCallback((item) => {
    if (!item || !item.label) return;

    setItems((prev) => [...prev, item]);
  }, []);

  const removeLastItem = useCallback(() => {
    setItems((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
  }, []);

  const clear = useCallback(() => {
    setItems([BASE_CRUMB]);
  }, []);

  const setPageBreadcrumb = useCallback((pageLabel, subLabel, options = {}) => {
    const { pageHref, subHref, tabLabel, tabHref } = options;
    setItems(buildItems({ pageLabel, pageHref, subLabel, subHref, tabLabel, tabHref }));
  }, []);

  const helpers = useMemo(
    () => ({
      setItems,
      addItem,
      removeLastItem,
      clear,
      setPageBreadcrumb,
    }),
    [addItem, removeLastItem, clear, setPageBreadcrumb]
  );

  return { items, helpers };
};

